"use client";

import {
  createContext,
  use,
  useContext,
  useEffect,
  useMemo,
  useState,
  type PropsWithChildren,
} from "react";
import { PageMapEntry } from "./loadPageCatalog";

type PageCatalogContextValue = {
  pages: Map<string, PageMapEntry> | undefined;
  setPages: (pages: Map<string, PageMapEntry> | undefined) => void;
};

const PageCatalogContext = createContext<PageCatalogContextValue | undefined>(
  undefined,
);

export function PageCatalogProvider({ children }: PropsWithChildren) {
  const [pages, setPages] = useState<Map<string, PageMapEntry> | undefined>();

  const value = useMemo(() => ({ pages, setPages }), [pages]);

  return (
    <PageCatalogContext.Provider value={value}>
      {children}
    </PageCatalogContext.Provider>
  );
}

export function usePageCatalog() {
  const context = useContext(PageCatalogContext);

  if (context === undefined) {
    throw new Error("usePageCatalog must be used within a PageCatalogProvider");
  }

  return context.pages;
}
export default function PageCatalogReader(props: {
  pageCatalog: Promise<Map<string, PageMapEntry>>;
}) {
  const pageCatalog = use(props.pageCatalog);
  const setPages = useContext(PageCatalogContext)?.setPages;

  useEffect(() => {
    setPages?.(pageCatalog);
  }, [pageCatalog, setPages]);

  return null;
}
